t = require('app/scripts/views/internal/teacup-with-helpers')('invitation')
memberTemplate = require './member'

module.exports = ->
  t.div '.phenom.invitation', ->

    t.mustacheBlock 'MemberInviter', ->
      t.div '.creator.member.no-menu', ->
        memberTemplate t.mustacheVar('MemberInviter')

    t.div '.phenom-desc', ->
      t.p ->

        t.mustacheBlock 'MemberInviter', ->
          t.format 'fullname-created-an-invitation-to', { fullName: t.mustacheVar('fullName') }

        t.span '.invitee', ->
          t.mustacheBlock 'MemberInvited', ->
            t.mustachePartial 'member_inline'
          t.mustacheBlockInverted 'MemberInvited', ->
            t.text t.mustacheVar('email')
            t.mustacheBlockInverted 'email', ->
              t.format 'someone-new'

    t.p '.phenom-meta.quiet', ->
      t.mustacheBlock 'dateExpires', ->
        t.span '.expiration-date', ->
          t.format 'expires', { dateExpires: t.mustacheVar('dateExpires') }
      t.mustacheBlock 'canRemove', ->
        t.text " - "
        t.a '.u-inline-block.js-remove-invitation', { href: '#' }, ->
          t.format 'delete-invitation'

